// extracted by mini-css-extract-plugin
export default {"rightContent":"index_rightContent_p6POT","title":"index_title_HWkhb","list":"index_list_2S71a","item":"index_item_9npih"};